export const accountPermissions = [
  'accounts-manage',
  'customers-manage',
  'customers-read',
  'subscriptions-preview',
  'subscriptions-manage',
  'payment-methods-manage',
  'payment-methods-read',
  'payment-methods-read-v1-deprecated',
  'invoices-pay',
  'invoices-read',
  'invoices-update',
  'trials-management',
  'sites-manage-mfa-enforcement',
  'topspin-create-team',
] as const;

export const organizationPermissions = [
  'sites-create',
  'visitor-lookups-create',
  'visitor-lookups-read',
  'org-ignored-ips-manage',
  'org-ignored-ips-read',
  'org-grant-support-access',
  'org-update',
  'org-invite',
  'org-user-update',
  'org-user-delete',
  'topspin-access-team',
  'api-key-create',
] as const;

export const sitePermissions = [
  'sites-delete',
  'sites-read',
  'sites-update',
  'user-attributes-read',
  'user-attributes-delete',
  'user-attributes-settings-update',
  'heatmaps-create',
  'heatmaps-delete',
  'heatmaps-read',
  'heatmaps-update',
  'highlights-create',
  'highlights-read',
  'highlights-update',
  'highlights-delete',
  'highlight-collections-create',
  'highlight-collections-read',
  'highlight-collections-update',
  'highlight-collections-delete',
  'highlight-labels-create',
  'highlight-labels-read',
  'highlight-labels-update',
  'highlight-labels-delete',
  'recordings-read',
  'recordings-update',
  'recordings-delete',
  'recordings-settings-update',
  'recordings-enable-capture-keystrokes',
  'segments-create',
  'segments-read',
  'segments-update',
  'segments-delete',
  'feedbacks-create',
  'feedbacks-read',
  'feedbacks-update',
  'feedbacks-delete',
  'feedbacks-responses-read',
  'feedbacks-responses-update',
  'feedbacks-responses-delete',
  'feedbacks-responses-vote',
  'responses-count-read',
  'surveys-create',
  'surveys-read',
  'surveys-update',
  'surveys-delete',
  'surveys-responses-read',
  'surveys-responses-update',
  'surveys-responses-vote',
  'surveys-responses-delete',
  'comments-create',
  'comments-read',
  'comments-update',
  'comments-delete',
  'short-urls-create',
  'site-feed-read',
  'site-integrations-update',
  'site-integrations-gtm-manage',
  'site-integrations-zapier-manage',
  'site-integration-tokens-create',
  'site-integration-tokens-update',
  'site-integration-tokens-read',
  'site-integration-tokens-delete',
  'site-integrations-ga-authorize',
  'site-integrations-ga-credentials-read',
  'site-integrations-ga-credentials-delete',
  'site-integrations-ga-goals-read',
  'site-integrations-slack-channels-read',
  'site-integrations-slack-config-create',
  'site-integrations-slack-config-read',
  'site-integrations-slack-config-update',
  'site-integrations-slack-config-delete',
  'site-integrations-slack-enroll',
  'site-integrations-status-read',
  'site-integrations-status-write',
  'site-integrations-teams-read',
  'site-integrations-teams-write',
  'site-integrations-webhooks-read',
  'site-integrations-webhooks-write',
  'site-plan-update',
  'site-plan-update-request',
  'site-transfer-to-org',
  'session-settings-read',
  'session-settings-update',
  'spaces-create',
  'spaces-read',
  'spaces-update',
  'spaces-archive',
  'dashboard-update',
] as const;
